import { all, takeEvery, call, put } from 'redux-saga/effects';
import actions from './actions';
import SuperFetch from '../../helpers/superFetch';
import { apiUrls } from '../../settings';

const doCancelSubscription = async (propertyHash) => {
  const body = {
    data: {
      propertyHash,
    }
  };
  return await SuperFetch.post(apiUrls.cancelPropertySubscription, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* cancelSubscription(action) {
  const response = yield call(doCancelSubscription, action.payload);
  if (response) {
    yield put(actions.doCancelSubscriptionSucceeded(response));
  } else {
    yield put(actions.doCancelSubscriptionFailed(response));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.DO_CANCEL_SUBSCRIPTION, cancelSubscription),
  ]);
}


// WEBPACK FOOTER //
// ./src/redux/cancelSubscription/sagas.js